import { Box, Modal, ModalBody, ModalContent, ModalOverlay, Text } from '@chakra-ui/react';
import React from 'react';
import { OutOfStockProps } from '../interfaces/components';
import { LoccitaneClose } from '../Icons/LoccitaneClose';
import { ProductComingSoon } from '../content';

const OutOfStock = ({ activeLocale, active, setActive }: OutOfStockProps) => {
  return (
    <Modal onClose={() => setActive(false)} isOpen={active}>
      <ModalOverlay />
      <ModalContent
        borderRadius="0px"
        m={['0px', '0px', 'auto', 'auto', 'auto']}
        h={['-webkit-fill-available', '-webkit-fill-available', '420px', '500px', '550px']}
        maxW={['100%', '100%', 'fit-content', 'fit-content', 'fit-content']}
        width={['100%', '100%', 'auto', 'auto', 'auto']}
        overflowY={['auto', 'auto', 'unset', 'unset', 'unset']}
        overflowX="hidden"
        position="fixed"
        top="0"
        left="0"
        bottom="0"
        right="0"
      >
        <LoccitaneClose
          position="absolute"
          top={['20px', '30px', '30px', '30px', '30px']}
          right={['20px', '30px', '30px', '30px', '30px']}
          boxSize={[6, 6, 8]}
          cursor="pointer"
          strokeWidth={0.5}
          zIndex={30}
          stroke="#CCCCCC"
          borderRadius="100%"
          _hover={{ stroke: 'black' }}
          transition=".5s"
          onClick={() => setActive(false)}
        />
        <ModalBody
          height={['auto', 'auto', '450px', '450px', '500px']}
          pointerEvents={active ? 'all' : 'none'}
          padding={['0px', '0px', '22px', '24px', '24px']}
          display="flex"
          flexDirection={['column', 'column', 'row', 'row', 'row']}
          justifyContent="space-between"
          gap="5"
        >
          <Box
            width={['100%', '100%', '420px', '500px', '550px']}
            maxH={['unset', 'unset', '450px', '450px', '500px']}
            h={['50%', '50%', 'unset', 'unset', 'unset']}
            display="flex"
            flexDirection={['column', 'column', 'column', 'column', 'column']}
            justifyContent="center"
            alignItems="center"
            position="relative"
          >
            <Text
              fontSize={['35px', '35px', '35px', '45px', '45px']}
              lineHeight={['35px', '35px', '35px', '45px', '45px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'LoccitaneRegular'}
              textAlign="center"
              textTransform="uppercase"
              w={['90%', '90%', '70%', '320px', '320px']}
              m="0 auto"
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof ProductComingSoon) in ProductComingSoon)
                ? ProductComingSoon['en'].title
                : ProductComingSoon[activeLocale as keyof typeof ProductComingSoon].title}
            </Text>
          </Box>
          <Box
            h={['50%', '50%', '370px', '450px', '500px']}
            w={['90%', '380px', '250px', '300px', '300px']}
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            margin={['20px auto', '20px auto', '0px', '0px', '0px']}
            padding={['20px', '20px', '20px', '25px', '25px 15px']}
            outline={'4px  solid #FFCB00'}
          >
            <Box
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
              fontSize={['15px']}
              textAlign="center"
              w={['100%', '100%', '100%', '220px', '220px']}
              m="0 auto"
              outline={'4px  solid #FFCB00'}
              p="10px"
              mt="auto"
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof ProductComingSoon) in ProductComingSoon)
                ? ProductComingSoon['en'].description
                : ProductComingSoon[activeLocale as keyof typeof ProductComingSoon].description}
            </Box>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default OutOfStock;
